import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'

function drawLegend (enter, update) {
	var data = update.data()[0]

	var fields = _.clone(data.domainData.legendFields)
	var descriptionIndex = _.findIndex(fields, f => f.property === 'showDescription')

	// description is kind of its own thing, and needs to go in a specific place,
	// which d3 isn't very good at. So just do it with jQuery
	if (descriptionIndex !== -1) {
		var content = $(update.node())
		var desc = content.find('.description')
		if (desc.length === 0) {
			desc = $('<div class="description"></div>').insertAfter(content.find('.shape-wrapper'))
		}
		desc.html(escapePreserveLineBreaks(fields[descriptionIndex].value))

		// remove description from the fields list so it doesn't show up with the other fields
		fields.splice(descriptionIndex, 1)
	} else {
		update.select('.description').remove()
	}

	update.classed('is-showing-description', descriptionIndex !== -1)

	var legend = update.selectAll('.legend').data(fields.length === 0 ? [] : [{ fields: fields }])

	legend.exit().remove()

	var field = legend.enter().append('div')
		  .classed('legend', true)
		  .merge(legend)
		  .selectAll('.legend-field').data(fields)

	var fieldEnter = field.enter().append('div')
								  .classed('legend-field', true)

	var allFields = fieldEnter.merge(field)
	field.exit().remove()

	fieldEnter.append('span').classed('label', true)
	allFields.select('.label').text(function (field) {
		if (field.property === 'showPeriod') {
			// #28846 period should be displayed by itself without a "Period: " label
			return field.value
		} else {
			return i18n.get(field.label) + ': '
		}
	})

	fieldEnter.append('span').classed('value', true)
	allFields.select('.value').text(function (field) {
		let value = field.property === 'showPeriod' ? '' : field.value
		let budgetValues = ['showBudgetVariancePercent', 'showBudgetVariance']
		if (_.includes(budgetValues, field.property)) {
			value = _.capitalize(value)
		}
		return value
	})
	allFields.select('.value').attr('data-unshortened-value', function (field) {
		// Some field values contain a numeric value and text. In those cases, the shortened
		// value to check against is contained in field.valueShortened #19211
		if (field.valueShortened) {
			return field.valueShortened != field.valueUnshortened ? field.valueUnshortened : null
		}
		return field.value != field.valueUnshortened ? field.valueUnshortened : null
	})
	allFields.select('.value').attr('data-unshortened-header', field => i18n.get(field.label))
}

export default drawLegend

drawLegend.__filename__ = 'dashboards/widgets/shape/view/draw-legend.js'
